function hexToArrayBuffer(hexString) {
  const result = [];
  let tmpHexString = hexString;
  while (tmpHexString.length >= 2) {
    result.push(Number.parseInt(tmpHexString.slice(0, 2), 16));
    tmpHexString = tmpHexString.slice(2);
  }
  return new Uint8Array(result);
}
async function deriveKeys(encodedKey) {
  var _a;
  if (!((_a = window == null ? void 0 : window.crypto) == null ? void 0 : _a.subtle)) {
    throw new Error("Environment does not support the SubtleCrypto API.");
  }
  const hash = "SHA-256";
  const length = 512;
  const salt = new ArrayBuffer(32);
  const info = "Sticker Pack";
  const masterKey = await window.crypto.subtle.importKey("raw", hexToArrayBuffer(encodedKey), "HKDF", false, ["deriveKey"]);
  const algorithm = {
    name: "HKDF",
    hash,
    salt,
    info: new TextEncoder().encode(info)
  };
  const derivedKeyAlgorithm = {
    name: "HMAC",
    hash,
    length
  };
  const derivedKeys = await window.crypto.subtle.deriveKey(algorithm, masterKey, derivedKeyAlgorithm, true, ["verify"]);
  const derivedKeyBytes = await window.crypto.subtle.exportKey("raw", derivedKeys);
  return [derivedKeyBytes.slice(0, 32), derivedKeyBytes.slice(32, 64)];
}
async function decryptManifest(encodedKey, rawManifest) {
  var _a;
  if (!((_a = window == null ? void 0 : window.crypto) == null ? void 0 : _a.subtle)) {
    throw new Error("Environment does not support the SubtleCrypto API.");
  }
  const keys = await deriveKeys(encodedKey);
  const encryptedManifest = new Uint8Array(rawManifest);
  const theirIv = encryptedManifest.slice(0, 16);
  const cipherTextBody = encryptedManifest.slice(16, encryptedManifest.byteLength - 32);
  const theirMac = encryptedManifest.slice(encryptedManifest.byteLength - 32, encryptedManifest.byteLength);
  const combinedCipherText = encryptedManifest.slice(0, encryptedManifest.byteLength - 32);
  const macKey = await window.crypto.subtle.importKey("raw", keys[1], {
    name: "HMAC",
    hash: {
      name: "SHA-256"
    }
  }, false, ["verify", "sign"]);
  const isValid = await window.crypto.subtle.verify("HMAC", macKey, theirMac, combinedCipherText);
  if (!isValid) {
    throw new Error("MAC verification failed.");
  }
  const cipherKey = await window.crypto.subtle.importKey("raw", keys[0], "AES-CBC", false, ["decrypt"]);
  return window.crypto.subtle.decrypt({ name: "AES-CBC", iv: theirIv }, cipherKey, cipherTextBody);
}
export {
  decryptManifest as default
};
//# sourceMappingURL=decrypt-manifest.browser.js.map
